const getSecretUrl = (keyId, version) => {
  const baseUrl = `/api/v1/bg/vault/secrets/${keyId}`;
  return version ? `${baseUrl}?version=${version}` : baseUrl;
};

export default getSecretUrl;
